import ConfirmForm from './ConfirmForm'

export {
  ConfirmForm
}



// WEBPACK FOOTER //
// ./src/views/Confirm/components/index.js